import React from 'react';
import { Box, Paper, Stack, Typography } from '@mui/material';

export const EntradaSection = ({ icon, title, children, sx }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: { xs: 1.5, sm: 2 },
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
        height: '100%',
        ...sx,
      }}
    >
      <Stack direction="row" spacing={1} sx={{ alignItems: 'center', mb: 1.5 }}>
        <Box sx={{ color: 'primary.main', display: 'flex' }}>
          {icon}
        </Box>
        <Typography variant="h3" sx={{ color: 'primary.main', fontWeight: 700 }}>
          {title}
        </Typography>
      </Stack>
      {children}
    </Paper>
  );
};
